import domready from 'domready'

function addSmoothAnchorScrollListener (anchor) {
  anchor.addEventListener('click', function (e) {
    const id = this.getAttribute('href').split('#')[1]
    if (id) {
      const element = document.getElementById(id)
      if (element) {
        e.preventDefault()
        element.scrollIntoView({
          behavior: 'smooth'
        })
      }
    }
  })
}

export default function initSmoothAnchorScroll () {
  domready(() => {
    const url = window.location.href.replace(window.location.hash, '').replace(/\/+$/, '')
    document.querySelectorAll(`.anchor-smooth-scroll, a[href^="#"], a[href^="${url}#"], a[href^="${url}/#"]`).forEach(anchor => {
      addSmoothAnchorScrollListener(anchor)
    })
  })
}
